
export const registrationInitialState = {
    name: "",
    tradeLicenseNumber: "",
    tradeLicenseExpiry: "",
    civilDefenseLicense: "",
    civilDefenseLicenseExpiry: "",
    categoryOfLicense: "",
    emirate: "",
    officeAddress: "",
    street: "",
    city: "",
    lon: "",
    lat: "",
    officePhoneNumber: "",
    contactPersonName: "",
    designation: "",
    phoneNumber: "",
    email: "",
    numberOfTechnician: "",
    numberofElectricalTechnician: "",
    numberOfMechanicalTechnician: "",
    numberOfCertifiedEngineers: "",
    numberOfElectricalEngineer: "",
    numberOfMechanicEngineer: "",
    cDApprovedLicense: "",
  };
  